import { 
  updateContainerStyles, 
  updateDividerStyles, 
  updateImageStyles,
  updateVideoStyles,
  updateAudioStyles,
  updateDocumentStyles,
  updateImageGridStyles,
  updateAccordionStyles,
  updateTextStyles,
  updateImageWithTextStyles,
  updateLinkWheelStyles,
  updateSocialMediaLinksStyles
} from '../reducers/PrevStylesCopy/CodeblockDefaultStyles';
import { 
  setGlobalCornerRounding as setGlobalCornerRoundingAction,
  setGlobalSettings as setGlobalSettingsAction,
  setGlobalborderThickness as setGlobalBorderThicknessAction,
  setGlobalMargin as setGlobalMarginAction,
  setGlobalHeadingProps as setGlobalHeadingPropsAction,
  setGlobalParagraphProps as setGlobalParagraphPropsAction,
  setGlobalLineHeight as setGlobalLineHeightAction
} from '../reducers/segmentBuilder';

// Action creator that synchronizes global corner rounding with container reducer
export const setGlobalCornerRounding = (value) => (dispatch, getState) => {
  // First, update the global settings
  dispatch(setGlobalCornerRoundingAction(value));
  
  // Then, update the container reducer with the new radius
  // We need to get the current containerProps to avoid overwriting other properties
  const containerProps = getState().codeblockStyles.container;
  
  // Create a new object with updated radius but keeping other properties
  const updatedContainerProps = {
    ...containerProps,
    radius: value
  };
  
  // Update the container reducer
  dispatch(updateContainerStyles(updatedContainerProps));

  // Also update the image reducer with border radius
  const imageProps = getState().codeblockStyles.image;
  
  // Create a new object with updated border radius but keeping other properties
  const updatedImageProps = {
    ...imageProps,
    borderRadius: value
  };
  
  // Update the image reducer
  dispatch(updateImageStyles(updatedImageProps));
  
  // Also update the video reducer with border radius
  const videoProps = getState().codeblockStyles.video;
  
  // Create a new object with updated border radius but keeping other properties
  const updatedVideoProps = {
    ...videoProps,
    borderRadius: value
  };
  
  // Update the video reducer
  dispatch(updateVideoStyles(updatedVideoProps));
  
  // Also update the imageGrid reducer with border radius
  const imageGridProps = getState().codeblockStyles.imageGrid;
  
  // Create a new object with updated border radius but keeping other properties
  const updatedImageGridProps = {
    ...imageGridProps,
    borderRadius: value
  };
  
  // Update the imageGrid reducer
  dispatch(updateImageGridStyles(updatedImageGridProps));
  
  // Also update the accordion reducer with border radius
  const accordionProps = getState().codeblockStyles.accordion;
  
  // Create a new object with updated border radius but keeping other properties
  const updatedAccordionProps = {
    ...accordionProps,
    borderRadius: value
  };
  
  // Update the accordion reducer
  dispatch(updateAccordionStyles(updatedAccordionProps));

  // Also update the imageWithText reducer with border radius
  const imageWithTextProps = getState().codeblockStyles.imageWithText;
  
  // Create a new object with updated border radius but keeping other properties
  const updatedImageWithTextProps = {
    ...imageWithTextProps,
    borderRadius: value
  };
  
  // Update the imageWithText reducer
  dispatch(updateImageWithTextStyles(updatedImageWithTextProps));
  
  // Also update the linkWheel reducer with border radius
  const linkWheelProps = getState().codeblockStyles.linkWheel;
  
  // Create a new object with updated border radius but keeping other properties
  const updatedLinkWheelProps = {
    ...linkWheelProps,
    borderRadius: value
  };
  
  // Update the linkWheel reducer
  dispatch(updateLinkWheelStyles(updatedLinkWheelProps));

  // Also update the socialMediaLinks reducer if needed
  const socialMediaLinksProps = getState().codeblockStyles.socialMediaLinks;
  
  // Create a new object with updated properties but keeping other properties
  const updatedSocialMediaLinksProps = {
    ...socialMediaLinksProps,
    borderRadius: value
  };
  
  // Update the socialMediaLinks reducer
  dispatch(updateSocialMediaLinksStyles(updatedSocialMediaLinksProps));
};

// Action creator that synchronizes border thickness with container reducer
export const setGlobalBorderThickness = (value) => (dispatch, getState) => {
  // First, update the global settings
  dispatch(setGlobalBorderThicknessAction(value));
  
  // Then, update the container reducer with the new border width
  // We need to get the current containerProps to avoid overwriting other properties
  const containerProps = getState().codeblockStyles.container;
  
  // Create a new object with updated border width but keeping other properties
  const updatedContainerProps = {
    ...containerProps,
    border: {
      ...containerProps.border,
      width: value
    }
  };
  
  // Update the container reducer
  dispatch(updateContainerStyles(updatedContainerProps));
  
  // Also update the image reducer with border width
  const imageProps = getState().codeblockStyles.image;
  
  // Create a new object with updated border width but keeping other properties
  const updatedImageProps = {
    ...imageProps,
    borderWidth: value
  };
  
  // Update the image reducer
  dispatch(updateImageStyles(updatedImageProps));
  
  // Also update the video reducer with border width
  const videoProps = getState().codeblockStyles.video;
  
  // Create a new object with updated border width but keeping other properties
  const updatedVideoProps = {
    ...videoProps,
    borderWidth: value
  };
  
  // Update the video reducer
  dispatch(updateVideoStyles(updatedVideoProps));
  
  // Also update the imageGrid reducer with border width
  const imageGridProps = getState().codeblockStyles.imageGrid;
  
  // Create a new object with updated border width but keeping other properties
  const updatedImageGridProps = {
    ...imageGridProps,
    borderWidth: value
  };
  
  // Update the imageGrid reducer
  dispatch(updateImageGridStyles(updatedImageGridProps));
  
  // Also update the accordion reducer with border width
  const accordionProps = getState().codeblockStyles.accordion;
  
  // Create a new object with updated border width but keeping other properties
  const updatedAccordionProps = {
    ...accordionProps,
    borderWidth: value
  };
  
  // Update the accordion reducer
  dispatch(updateAccordionStyles(updatedAccordionProps));
  
  // Also update the imageWithText reducer with border width
  const imageWithTextProps = getState().codeblockStyles.imageWithText;
  
  // Create a new object with updated border width but keeping other properties
  const updatedImageWithTextProps = {
    ...imageWithTextProps,
    borderWidth: value
  };
  
  // Update the imageWithText reducer
  dispatch(updateImageWithTextStyles(updatedImageWithTextProps));
  
  // Also update the linkWheel reducer with border width
  const linkWheelProps = getState().codeblockStyles.linkWheel;
  
  // Create a new object with updated border width but keeping other properties
  const updatedLinkWheelProps = {
    ...linkWheelProps,
    borderWidth: value
  };
  
  // Update the linkWheel reducer
  dispatch(updateLinkWheelStyles(updatedLinkWheelProps));
  
  // Also update the socialMediaLinks reducer if needed
  const socialMediaLinksProps = getState().codeblockStyles.socialMediaLinks;
  
  // Create a new object with updated border width but keeping other properties
  const updatedSocialMediaLinksProps = {
    ...socialMediaLinksProps,
    borderWidth: value
  };
  
  // Update the socialMediaLinks reducer
  dispatch(updateSocialMediaLinksStyles(updatedSocialMediaLinksProps));
};

// Action creator that synchronizes margins with container reducer
export const setGlobalMargin = (margin) => (dispatch, getState) => {
  // First, update the global settings
  dispatch(setGlobalMarginAction(margin));
  
  // Then, update the container reducer
  const containerProps = getState().codeblockStyles.container;
  
  // Create a new object with updated margin but keeping other properties
  const updatedContainerProps = {
    ...containerProps,
    margin: margin
  };
  
  // Update the container reducer
  dispatch(updateContainerStyles(updatedContainerProps));
  
  // Also update the divider reducer
  const dividerProps = getState().codeblockStyles.divider;
  
  // Create a new object with updated margin but keeping other properties
  const updatedDividerProps = {
    ...dividerProps,
    margin: margin
  };
  
  // Update the divider reducer
  dispatch(updateDividerStyles(updatedDividerProps));

  // Also update the image reducer
  const imageProps = getState().codeblockStyles.image;
  
  // Create a new object with updated margin but keeping other properties
  const updatedImageProps = {
    ...imageProps,
    margin: margin
  };
  
  // Update the image reducer
  dispatch(updateImageStyles(updatedImageProps));
  
  // Also update the video reducer
  const videoProps = getState().codeblockStyles.video;
  
  // Create a new object with updated margin but keeping other properties
  const updatedVideoProps = {
    ...videoProps,
    margin: margin
  };
  
  // Update the video reducer
  dispatch(updateVideoStyles(updatedVideoProps));
  
  // Also update the audio reducer
  const audioProps = getState().codeblockStyles.audio;
  
  // Create a new object with updated margin but keeping other properties
  const updatedAudioProps = {
    ...audioProps,
    margin: margin
  };
  
  // Update the audio reducer
  dispatch(updateAudioStyles(updatedAudioProps));
  
  // Also update the document reducer
  const documentProps = getState().codeblockStyles.document;
  
  // Create a new object with updated margin but keeping other properties
  const updatedDocumentProps = {
    ...documentProps,
    margin: margin
  };
  
  // Update the document reducer
  dispatch(updateDocumentStyles(updatedDocumentProps));
  
  // Also update the imageGrid reducer
  const imageGridProps = getState().codeblockStyles.imageGrid;
  
  // Create a new object with updated margin but keeping other properties
  const updatedImageGridProps = {
    ...imageGridProps,
    margin: margin
  };
  
  // Update the imageGrid reducer
  dispatch(updateImageGridStyles(updatedImageGridProps));
  
  // Also update the accordion reducer
  const accordionProps = getState().codeblockStyles.accordion;
  
  // Create a new object with updated margin but keeping other properties
  const updatedAccordionProps = {
    ...accordionProps,
    margin: margin
  };
  
  // Update the accordion reducer
  dispatch(updateAccordionStyles(updatedAccordionProps));

  // Also update the text reducer - we need to update padding instead of margin
  const textProps = getState().codeblockStyles.text;
  
  // Create a new object with updated padding but keeping other properties
  const updatedTextProps = {
    ...textProps,
    padding: {
      top: margin.top,
      right: margin.right,
      bottom: margin.bottom,
      left: margin.left
    }
  };
  
  // Update the text reducer
  dispatch(updateTextStyles(updatedTextProps));
  
  // Also update the imageWithText reducer - we need to update margin
  const imageWithTextProps = getState().codeblockStyles.imageWithText;
  
  // Create a new object with updated margin but keeping other properties
  const updatedImageWithTextProps = {
    ...imageWithTextProps,
    margin: { ...margin }
  };
  
  // Update the imageWithText reducer
  dispatch(updateImageWithTextStyles(updatedImageWithTextProps));
  
  // Also update the linkWheel reducer - we need to update margin
  const linkWheelProps = getState().codeblockStyles.linkWheel;
  
  // Create a new object with updated margin but keeping other properties
  const updatedLinkWheelProps = {
    ...linkWheelProps,
    margin: { ...margin }
  };
  
  // Update the linkWheel reducer
  dispatch(updateLinkWheelStyles(updatedLinkWheelProps));

  // Also update the socialMediaLinks reducer with margin
  const socialMediaLinksProps = getState().codeblockStyles.socialMediaLinks;
  
  // Create a new object with updated margin but keeping other properties
  const updatedSocialMediaLinksProps = {
    ...socialMediaLinksProps,
    margin: { ...margin }
  };
  
  // Update the socialMediaLinks reducer
  dispatch(updateSocialMediaLinksStyles(updatedSocialMediaLinksProps));
};

// Action creator that synchronizes all global settings with container reducer
export const setGlobalSettings = (settings) => (dispatch, getState) => {
  // First, update the global settings
  dispatch(setGlobalSettingsAction(settings));
  
  // Then, update the container reducer
  const containerProps = getState().codeblockStyles.container;
  
  // Create a new object with updated properties but keeping other properties
  const updatedContainerProps = {
    ...containerProps,
    radius: settings.cornerRounding,
    margin: settings.margin,
    border: {
      ...containerProps.border,
      width: settings.borderThickness
    }
  };
  
  // Update the container reducer
  dispatch(updateContainerStyles(updatedContainerProps));
  
  // Also update the divider reducer - BUT only with margin as per requirements
  const dividerProps = getState().codeblockStyles.divider;
  
  // Create a new object with updated properties but keeping other properties
  const updatedDividerProps = {
    ...dividerProps,
    margin: settings.margin
  };
  
  // Update the divider reducer
  dispatch(updateDividerStyles(updatedDividerProps));

  // Also update the image reducer
  const imageProps = getState().codeblockStyles.image;
  
  // Create a new object with updated properties but keeping other properties
  const updatedImageProps = {
    ...imageProps,
    borderRadius: settings.cornerRounding,
    margin: settings.margin,
    borderWidth: settings.borderThickness
  };
  
  // Update the image reducer
  dispatch(updateImageStyles(updatedImageProps));
  
  // Also update the video reducer
  const videoProps = getState().codeblockStyles.video;
  
  // Create a new object with updated properties but keeping other properties
  const updatedVideoProps = {
    ...videoProps,
    borderRadius: settings.cornerRounding,
    margin: settings.margin,
    borderWidth: settings.borderThickness
  };
  
  // Update the video reducer
  dispatch(updateVideoStyles(updatedVideoProps));
  
  // Also update the audio reducer - BUT only with margin
  const audioProps = getState().codeblockStyles.audio;
  
  // Create a new object with updated properties but keeping other properties
  const updatedAudioProps = {
    ...audioProps,
    margin: settings.margin
  };
  
  // Update the audio reducer
  dispatch(updateAudioStyles(updatedAudioProps));
  
  // Also update the document reducer - BUT only with margin
  const documentProps = getState().codeblockStyles.document;
  
  // Create a new object with updated properties but keeping other properties
  const updatedDocumentProps = {
    ...documentProps,
    margin: settings.margin
  };
  
  // Update the document reducer
  dispatch(updateDocumentStyles(updatedDocumentProps));
  
  // Also update the imageGrid reducer
  const imageGridProps = getState().codeblockStyles.imageGrid;
  
  // Create a new object with updated properties but keeping other properties
  const updatedImageGridProps = {
    ...imageGridProps,
    borderRadius: settings.cornerRounding,
    margin: settings.margin,
    borderWidth: settings.borderThickness
  };
  
  // Update the imageGrid reducer
  dispatch(updateImageGridStyles(updatedImageGridProps));
  
  // Also update the accordion reducer
  const accordionProps = getState().codeblockStyles.accordion;
  
  // Create a new object with updated properties but keeping other properties
  const updatedAccordionProps = {
    ...accordionProps,
    borderRadius: settings.cornerRounding,
    margin: settings.margin,
    borderWidth: settings.borderThickness
  };
  
  // Update the accordion reducer
  dispatch(updateAccordionStyles(updatedAccordionProps));

  // Update the text reducer with padding and text-specific properties
  const textProps = getState().codeblockStyles.text;
  
  // Create a new object with updated properties but keeping other properties
  const updatedTextProps = {
    ...textProps,
    padding: {
      top: settings.margin.top,
      right: settings.margin.right,
      bottom: settings.margin.bottom,
      left: settings.margin.left
    },
    headingProps: settings.headingProps || textProps.headingProps,
    paragraphProps: settings.paragraphProps || textProps.paragraphProps,
    lineHeight: settings.lineHeight || textProps.lineHeight
  };
  
  // Update the text reducer
  dispatch(updateTextStyles(updatedTextProps));
  
  // Update the imageWithText reducer with margin and text-specific properties
  const imageWithTextProps = getState().codeblockStyles.imageWithText;
  
  // Create a new object with updated margin but keeping other properties
  const updatedImageWithTextProps = {
    ...imageWithTextProps,
    margin: { ...settings.margin },
    borderRadius: settings.cornerRounding,
    borderWidth: settings.borderThickness,
    headingProps: settings.headingProps ? { ...settings.headingProps } : { ...imageWithTextProps.headingProps },
    paragraphProps: settings.paragraphProps ? { ...settings.paragraphProps } : { ...imageWithTextProps.paragraphProps },
    lineHeight: settings.lineHeight || imageWithTextProps.lineHeight
  };
  
  // Update the imageWithText reducer
  dispatch(updateImageWithTextStyles(updatedImageWithTextProps));
  
  // Update the linkWheel reducer with margin, borderRadius, and borderWidth
  const linkWheelProps = getState().codeblockStyles.linkWheel;
  
  // Create a new object with updated properties but keeping other properties
  const updatedLinkWheelProps = {
    ...linkWheelProps,
    margin: { ...settings.margin },
    borderRadius: settings.cornerRounding,
    borderWidth: settings.borderThickness
  };
  
  // Update the linkWheel reducer
  dispatch(updateLinkWheelStyles(updatedLinkWheelProps));

  // Update the socialMediaLinks reducer with global settings
  const socialMediaLinksProps = getState().codeblockStyles.socialMediaLinks;
  
  // Create a new object with updated properties but keeping other properties
  const updatedSocialMediaLinksProps = {
    ...socialMediaLinksProps,
    margin: { ...settings.margin }
  };
  
  // Update the socialMediaLinks reducer
  dispatch(updateSocialMediaLinksStyles(updatedSocialMediaLinksProps));
};

// // Action creator that synchronizes heading props with text reducer
// export const setGlobalHeadingProps = (headingProps) => (dispatch, getState) => {
//   // First, update the global settings
//   dispatch(setGlobalHeadingPropsAction(headingProps));
  
//   // Then, update the text reducer with the new heading props
//   const textProps = getState().codeblockStyles.text;
  
//   // Create a new object with updated heading props but keeping other properties
//   const updatedTextProps = {
//     ...textProps,
//     headingProps: headingProps
//   };
  
//   // Update the text reducer
//   dispatch(updateTextStyles(updatedTextProps));
  
//   // Also update the imageWithText reducer
//   const imageWithTextProps = getState().codeblockStyles.imageWithText;
  
//   // Create a new object with updated heading props but keeping other properties
//   const updatedImageWithTextProps = {
//     ...imageWithTextProps,
//     headingProps: headingProps
//   };
  
//   // Update the imageWithText reducer
//   dispatch(updateImageWithTextStyles(updatedImageWithTextProps));
// };

// Action creator that synchronizes paragraph props with text reducer
// export const setGlobalParagraphProps = (paragraphProps) => (dispatch, getState) => {
//   // First, update the global settings
//   dispatch(setGlobalParagraphPropsAction(paragraphProps));
  
//   // Then, update the text reducer with the new paragraph props
//   const textProps = getState().codeblockStyles.text;
  
//   // Create a new object with updated paragraph props but keeping other properties
//   const updatedTextProps = {
//     ...textProps,
//     paragraphProps: paragraphProps
//   };
  
//   // Update the text reducer
//   dispatch(updateTextStyles(updatedTextProps));
  
//   // Also update the imageWithText reducer
//   const imageWithTextProps = getState().codeblockStyles.imageWithText;
  
//   // Create a new object with updated paragraph props but keeping other properties
//   const updatedImageWithTextProps = {
//     ...imageWithTextProps,
//     paragraphProps: paragraphProps
//   };
  
//   // Update the imageWithText reducer
//   dispatch(updateImageWithTextStyles(updatedImageWithTextProps));
// };

// // Action creator that synchronizes line height with text reducer
// export const setGlobalLineHeight = (lineHeight) => (dispatch, getState) => {
//   // First, update the global settings
//   dispatch(setGlobalLineHeightAction(lineHeight));
  
//   // Then, update the text reducer with the new line height
//   const textProps = getState().codeblockStyles.text;
  
//   // Create a new object with updated line height but keeping other properties
//   const updatedTextProps = {
//     ...textProps,
//     lineHeight: lineHeight
//   };
  
//   // Update the text reducer
//   dispatch(updateTextStyles(updatedTextProps));
  
//   // Also update the imageWithText reducer
//   const imageWithTextProps = getState().codeblockStyles.imageWithText;
  
//   // Create a new object with updated line height but keeping other properties
//   const updatedImageWithTextProps = {
//     ...imageWithTextProps,
//     lineHeight: lineHeight
//   };
  
//   // Update the imageWithText reducer
//   dispatch(updateImageWithTextStyles(updatedImageWithTextProps));
// }; 